import Modal from 'react-bootstrap/Modal';
import PropTypes from 'prop-types';
import React from 'react';
import PayableIntegrationServicePayableDetails from './PayableIntegrationServicePayableDetails';

class PayableIntegrationServiceModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payable: props.payable,
      isOpen: props.isOpen,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.showModal(this.props.isOpen);
    }
  }

  showModal = (isOpen) => {
    this.setState({
      isOpen,
    });
  };

  render() {
    const { isOpen, payable, } = this.state;
    const { toggleModal, } = this.props;

    return (
        <Modal show={isOpen} onHide={() => toggleModal()} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>
              Payable ID:&nbsp;
              {payable._id}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isOpen && <PayableIntegrationServicePayableDetails payable={payable} />}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
    );
  }
}

PayableIntegrationServiceModal.propTypes = {
  payable: PropTypes.instanceOf(Object).isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

export default PayableIntegrationServiceModal;
